import * as React from 'react'
import styled from 'styled-components';
import useResizeObserver from "use-resize-observer"

const Container = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
`

interface IProps {
  children: (props: { width: number; height: number }) => React.ReactNode;
}

const ResizeObserver = (props: IProps) => {
  const { children } = props
  const { ref, width, height } = useResizeObserver();

  return (
    <Container ref={ref} className='document-wrapper'>
      {children({ width: width, height: height })}
    </Container>
  )
}

export default ResizeObserver